var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"bg-effect popup-bg",on:{"click":function($event){return _vm.hide()}}}),_c('div',{staticClass:"base-popup"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }